// ===========================================
// BUSTED! BLACKJACK - SHARED ENUMS
// ===========================================
// ----- User & Auth -----
export var OAuthProvider;
(function (OAuthProvider) {
    OAuthProvider["GOOGLE"] = "google";
    OAuthProvider["DISCORD"] = "discord";
    OAuthProvider["TWITTER"] = "twitter";
})(OAuthProvider || (OAuthProvider = {}));
export var UserRole;
(function (UserRole) {
    UserRole["PLAYER"] = "player";
    UserRole["SPONSOR"] = "sponsor";
    UserRole["ADMIN"] = "admin";
})(UserRole || (UserRole = {}));
// ----- Tables -----
export var TableType;
(function (TableType) {
    TableType["PUBLIC"] = "public";
    TableType["PRIVATE"] = "private";
    TableType["SPONSORED"] = "sponsored";
})(TableType || (TableType = {}));
export var TableStatus;
(function (TableStatus) {
    TableStatus["ACTIVE"] = "active";
    TableStatus["INACTIVE"] = "inactive";
    TableStatus["CLOSED"] = "closed";
})(TableStatus || (TableStatus = {}));
// ----- Game States -----
export var GamePhase;
(function (GamePhase) {
    GamePhase["WAITING"] = "waiting";
    GamePhase["BETTING"] = "betting";
    GamePhase["DEALING"] = "dealing";
    GamePhase["PLAYING"] = "playing";
    GamePhase["DEALER_TURN"] = "dealer_turn";
    GamePhase["RESOLVING"] = "resolving";
})(GamePhase || (GamePhase = {}));
export var PlayerAction;
(function (PlayerAction) {
    PlayerAction["HIT"] = "hit";
    PlayerAction["STAND"] = "stand";
    PlayerAction["DOUBLE"] = "double";
    PlayerAction["SPLIT"] = "split";
    PlayerAction["SURRENDER"] = "surrender";
})(PlayerAction || (PlayerAction = {}));
export var HandOutcome;
(function (HandOutcome) {
    HandOutcome["WIN"] = "win";
    HandOutcome["LOSE"] = "lose";
    HandOutcome["PUSH"] = "push";
    HandOutcome["BLACKJACK"] = "blackjack";
    HandOutcome["BUST"] = "bust";
    HandOutcome["SURRENDER"] = "surrender";
})(HandOutcome || (HandOutcome = {}));
// ----- Seat Status -----
export var SeatStatus;
(function (SeatStatus) {
    SeatStatus["EMPTY"] = "empty";
    SeatStatus["OCCUPIED"] = "occupied";
    SeatStatus["RESERVED"] = "reserved";
})(SeatStatus || (SeatStatus = {}));
export var SpectatorMode;
(function (SpectatorMode) {
    SpectatorMode["WATCH"] = "watch";
    SpectatorMode["WAIT"] = "wait";
})(SpectatorMode || (SpectatorMode = {}));
// ----- Cosmetics -----
export var CosmeticCategory;
(function (CosmeticCategory) {
    CosmeticCategory["CHIPS"] = "chips";
    CosmeticCategory["CARDS"] = "cards";
    CosmeticCategory["TABLE"] = "table";
    CosmeticCategory["SOUNDS"] = "sounds";
    CosmeticCategory["BADGES"] = "badges";
})(CosmeticCategory || (CosmeticCategory = {}));
export var CosmeticRarity;
(function (CosmeticRarity) {
    CosmeticRarity["COMMON"] = "common";
    CosmeticRarity["UNCOMMON"] = "uncommon";
    CosmeticRarity["RARE"] = "rare";
    CosmeticRarity["EPIC"] = "epic";
    CosmeticRarity["LEGENDARY"] = "legendary";
    CosmeticRarity["SPONSORED"] = "sponsored";
})(CosmeticRarity || (CosmeticRarity = {}));
// ----- Transactions -----
export var TransactionType;
(function (TransactionType) {
    TransactionType["CHIP_PURCHASE"] = "chip_purchase";
    TransactionType["COSMETIC_PURCHASE"] = "cosmetic_purchase";
    TransactionType["DAILY_CLAIM"] = "daily_claim";
    TransactionType["USERNAME_CHANGE"] = "username_change";
    TransactionType["BUTTON_POWER"] = "button_power";
    TransactionType["GAME_WIN"] = "game_win";
    TransactionType["GAME_LOSS"] = "game_loss";
    TransactionType["SPONSOR_PAYMENT"] = "sponsor_payment";
})(TransactionType || (TransactionType = {}));
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["PENDING"] = "pending";
    PaymentStatus["COMPLETED"] = "completed";
    PaymentStatus["FAILED"] = "failed";
    PaymentStatus["REFUNDED"] = "refunded";
})(PaymentStatus || (PaymentStatus = {}));
// ----- Sponsorship -----
export var SponsorPlan;
(function (SponsorPlan) {
    SponsorPlan["DAILY"] = "daily";
    SponsorPlan["WEEKLY"] = "weekly";
    SponsorPlan["MONTHLY"] = "monthly";
})(SponsorPlan || (SponsorPlan = {}));
export var AssetStatus;
(function (AssetStatus) {
    AssetStatus["PENDING"] = "pending";
    AssetStatus["APPROVED"] = "approved";
    AssetStatus["REJECTED"] = "rejected";
})(AssetStatus || (AssetStatus = {}));
// ----- Quests -----
export var QuestCriteriaType;
(function (QuestCriteriaType) {
    QuestCriteriaType["HANDS_PLAYED"] = "hands_played";
    QuestCriteriaType["WINS"] = "wins";
    QuestCriteriaType["HOURS_PLAYED"] = "hours_played";
})(QuestCriteriaType || (QuestCriteriaType = {}));
// ----- Activity Feed -----
export var ActivityEventType;
(function (ActivityEventType) {
    ActivityEventType["BIG_WIN"] = "big_win";
    ActivityEventType["BLACKJACK"] = "blackjack";
    ActivityEventType["NEW_ARRIVAL"] = "new_arrival";
    ActivityEventType["TABLE_CREATED"] = "table_created";
    ActivityEventType["ACHIEVEMENT_UNLOCKED"] = "achievement_unlocked";
    ActivityEventType["BUTTON_POWER_FLEX"] = "button_power_flex";
})(ActivityEventType || (ActivityEventType = {}));
//# sourceMappingURL=enums.js.map